import browserCookies from 'browser-cookies';
import { setErrorReporterSessionData } from '@americanexpress/one-app-ducks';

export const TEALEAF_SESSION_ID_COOKIE_NAME = 'TLTSID';

export const addTealeafIdToErrorReporting = (dispatch, getState) => {
  let tealeafUUID = getState().getIn(['errorReporting', 'sessionData', 'tealeafUUID']);
  if (tealeafUUID) {
    return tealeafUUID;
  }
  tealeafUUID = browserCookies.get(TEALEAF_SESSION_ID_COOKIE_NAME);
  if (tealeafUUID) {
    try {
      dispatch(setErrorReporterSessionData({
        tealeafUUID,
      }));
    } catch (e) {
      // putting this here to prevent the app from crashing if the error reporter session data fails
    }
    return tealeafUUID;
  }
  return null;
};

export const addLazyLoadTealeafIdToErrorReporting = async (dispatch, getState) => {
  let attempts = 0;
  let tealeafUUID = addTealeafIdToErrorReporting(dispatch, getState);
  while (!tealeafUUID && attempts < 200) {
    // eslint-disable-next-line no-await-in-loop,no-promise-executor-return -- we need to wait in case the cookie takes a while to appear
    await new Promise((resolve) => setTimeout(resolve, 10));
    tealeafUUID = addTealeafIdToErrorReporting(dispatch, getState);
    attempts += 1;
  }
};
